let filterSortHtml = "";
var clearAllFilterButton = !1,
    minPriceRange = "",
    maxPriceRang = "";
function showMoreFilters() {
    var e = document.querySelectorAll(".filters-expand");
    e &&
        Array.from(e).forEach(function (e) {
            e.addEventListener("click", (t) => {
                t.preventDefault(),
                    e.classList.contains("active")
                        ? (e.classList.remove("active"),
                          e.closest(".filter-item").classList.remove("show-more-filter"),
                          DOMAnimations.slideUp(e.parentNode.querySelector(".more-options"), 150),
                          (e.querySelector("strong").textContent = showMoreText))
                        : (e.classList.add("active"),
                          e.closest(".filter-item").classList.add("show-more-filter"),
                          DOMAnimations.slideDown(e.parentNode.querySelector(".more-options"), 150),
                          (e.querySelector("strong").textContent = showLessText));
            });
            let t = new MouseEvent("mouseover", { bubbles: !0, cancelable: !0, view: window });
            e.onkeydown = function (r) {
                (13 == r.keyCode || 32 == r.keyCode) &&
                    (e.dispatchEvent(t),
                    setTimeout(() => {
                        "" == previousFocusElement && (previousFocusElement = this), e.parentNode.querySelector(".more-options input").focus();
                    }, 500));
            };
        });
}
function dropDownBar(e = document) {
    document.querySelectorAll("[data-dropdown-head]") &&
        Array.from(document.querySelectorAll("[data-dropdown-head]")).forEach(function (e) {
            e.addEventListener("click", (t) => {
                t.preventDefault();
                let r = e.closest(".shopify-section"),
                    o = r.querySelector("[data-dropdown-body]");
                r.querySelector("[data-dropdown-body]").classList.contains("is-open")
                    ? r.querySelector("[data-dropdown-body]").classList.remove("is-open")
                    : (r.querySelector("[data-dropdown-body]").classList.add("is-open"),
                      setTimeout(() => {
                          (previousFocusElement = e), o && focusElementsRotation(o);
                      }, 300));
            });
            let t = new MouseEvent("mouseover", { bubbles: !0, cancelable: !0, view: window });
            e.onkeydown = function (r) {
                let o = e.closest(".shopify-section").querySelector("[data-dropdown-body]");
                (13 == r.keyCode || 32 == r.keyCode) &&
                    (o.dispatchEvent(t),
                    setTimeout(() => {
                        "" == previousFocusElement && (previousFocusElement = this), o && focusElementsRotation(o);
                    }, 300));
            };
        });
}

function applyFilters(e) {
    if (document.querySelector("[data-products-container]")) {
        var t = document.querySelector("[data-products-container]"),
            r = t.closest(".shopify-section");
        if (t) {
            var o = t.dataset.id;
            let n = document.querySelector(".main-products-wrapper");
            if (!n) return !1;
            if (
                (Array.from(document.querySelectorAll(".filter-price-option-item")).forEach(function (e) {
                    let t = e.querySelectorAll(".filter-option-range-input input"),
                        r = e.querySelectorAll(".filter-option-price-input input"),
                        n = e.querySelector(".price-progress-bar");
                    if (t.length > 0) {
                        let l = t[0].getAttribute("step");
                        r.forEach((e) => {
                            e.addEventListener("change", (t) => {
                                let n = parseInt(r[0].value),
                                    l = parseInt(r[1].getAttribute("data-max-value"));
                                n > l && ((n = l), (r[0].value = n)), getFilterData(e, o);
                            });
                        }),
                            t.forEach((e) => {
                                e.addEventListener("change", (t) => {
                                    i(e, t), getFilterData(e, o);
                                }),
                                    e.addEventListener("input", (t) => {
                                        i(e, t);
                                    });
                            });
                        var i = function (e, o) {
                            let i = parseInt(t[0].value),
                                a = parseInt(t[1].value);
                            (minPriceRange = (i / t[0].max) * 100 + "%"),
                                (maxPriceRang = 100 - (a / t[1].max) * 100 + "%"),
                                a - i < l
                                    ? "price-slider-range-min" === o.target.className
                                        ? (t[0].value = a - l)
                                        : (t[1].value = i + l)
                                    : ((r[0].value = i), (r[1].value = a), (n.style.left = minPriceRange), (n.style.right = maxPriceRang));
                        };
                    }
                }),
                window.innerWidth > 320)
            ) {
                if (
                    (Array.from(n.querySelectorAll("input[type=checkbox]")).forEach(function (e) {
                        e.addEventListener("click", () => {
                            window.innerWidth > 320 && getFilterData(e, o);
                        });
                    }),
                    r.querySelector("#applyFilter"))
                ) {
                    let l = r.querySelector("#applyFilter");
                    Array.from(document.querySelectorAll("#filterForm, #filterFormdropdown")).forEach(function (e) {
                        e.addEventListener("keydown", function (e) {
                            "input" === e.target.tagName.toLowerCase() && "Enter" === e.key && e.preventDefault();
                        });
                    }),
                        l.addEventListener("click", (e) => {
                            e.preventDefault(),
                                window.innerWidth > 320 &&
                                    (setTimeout(function () {
                                        r.querySelector("[data-dropdown-body]") && r.querySelector("[data-dropdown-body]").classList.remove("is-open"),
                                            r.querySelector("[data-filter-drawer]") && r.querySelector("[data-filter-drawer]").classList.remove("show");
                                    }, 300),
                                    setTimeout(function () {
                                        r.querySelector("[data-filter-drawer]") && (r.querySelector("[data-filter-drawer]").style.display = "none");
                                    }, 500),
                                    document.querySelector("body").classList.remove("no-scroll"));
                        });
                }
            } 
            else
                void 0 == e &&
                    Array.from(n.querySelectorAll("form")).forEach(function (e) {
                        e.addEventListener("submit", (t) => {
                            t.preventDefault(),
                                getFilterData(e, o),
                                setTimeout(function () {
                                    r.querySelector("[data-dropdown-body]") && r.querySelector("[data-dropdown-body]").classList.remove("is-open"),
                                        r.querySelector("[data-filter-drawer]") && r.querySelector("[data-filter-drawer]").classList.remove("show");
                                }, 300),
                                setTimeout(function () {
                                    r.querySelector("[data-filter-drawer]").style.display = "none";
                                }, 500),
                                document.querySelector("body").classList.remove("no-scroll");
                        });
                    });
        }
    }
}


function removeFilter() {
    var e = document.querySelectorAll("a.applied-filter-remove"),
        t = document.querySelector("[data-products-container]");
    if (t) {
        var r = t.dataset.id;
        Array.from(e).forEach(function (e) {
            e.addEventListener("click", (t) => {
                if ((t.preventDefault(), e.hasAttribute("applied-filter-cross-all"))) {
                    var o = e.getAttribute("href");
                    return getFilterData(e, r, o), !1;
                }
                var o = e.getAttribute("href");
                getFilterData(e, r, o);
            });
        });
    }
}
function sortByOptions() {
    var e = document.querySelector("[data-products-container]"),
        t = document.querySelectorAll('[name="sort_by"]'),
        r = document.querySelectorAll("[data-sort-option]");
    if (e) {
        var o = e.dataset.id;
        Array.from(t).forEach(function (e) {
            e.addEventListener("change", (r) => {
                let n = e.getAttribute("data-name");
                Array.from(t).forEach(function (e) {
                    e.parentNode.classList.remove("selected");
                }),
                    e.parentNode.classList.add("selected"),
                    getFilterData(e, o),
                    (e.closest(".filter-bar-right").querySelector(".custom-select-text").innerHTML = `<strong>${n}</strong>`);
            });
        }),
            Array.from(r).forEach(function (e) {
                e.addEventListener("click", (t) => {
                    triggerEvent(e);
                }),
                    e.addEventListener("keydown", (t) => {
                        (13 == t.keyCode || 32 == t.keyCode) && triggerEvent(e);
                    });
            });
    }
}
function triggerEvent(e) {
    e.parentNode.querySelector("input").checked = !0;
    let t = new Event("change", { bubbles: !0, cancelable: !0, view: window });
    e.parentNode.querySelector("input").dispatchEvent(t);
}
function fetchFilterData(e) {
    return fetch(e).then((e) => e.text());
}
function getFilterData(e, t, r) {
    let o = e.closest("form"),
        n = "",
        l = "";
    if (("filterForm" == e.getAttribute("form") && document.getElementById(e.getAttribute("form")) && (o = document.getElementById(e.getAttribute("form"))), o || r)) {
        if ((e.closest(".shopify-section"), o)) {
            let i = new FormData(o),
                a = new URLSearchParams(i).toString();
            (n = window.location.pathname + "?section_id=" + t + "&" + a), (l = window.location.pathname + "?" + a);
        }
        r && ((n = r), (l = r)),
            fetchFilterData(n).then((e) => {
                let t = new DOMParser().parseFromString(e, "text/html");
                var r = t.querySelector("[data-products-container]"),
                    o = document.querySelector("[data-products-container]");
                if (r) {
                    o.innerHTML = r.innerHTML;
                    Array.from(o.querySelectorAll("[data-quickview-action]")).forEach(function (e) {
                        initQuickView(e);
                    }),
                        colorSwatchesMediaChanged(o);
                }
                t.querySelector("[data-search-result-count]") && (document.querySelector("[data-search-result-count]").textContent = t.querySelector("[data-search-result-count]").textContent),
                    t.querySelector("[data-sorting-content]") && ((document.querySelector("[data-sorting-content]").innerHTML = t.querySelector("[data-sorting-content]").innerHTML), sortByOptions());
                var n = document.querySelectorAll(".filter-item");
                Array.from(t.querySelectorAll(".filter-item")).forEach(function (e, t) {
                    let r = n[t];
                    if (r.querySelector(".price-slider-range-min")) {
                        // console.log(r),
                            (r.querySelector(".filter-option-range-input").innerHTML = e.querySelector(".filter-option-range-input").innerHTML),
                            (r.querySelector(".filter-option-price-input").innerHTML = e.querySelector(".filter-option-price-input").innerHTML);
                        let o = r.querySelectorAll(".filter-option-range-input input");
                        (minVal = parseInt(o[0].value)),
                            (rangeselector = e.querySelector(".price-progress-bar")),
                            (maxVal = parseInt(o[1].value)),
                            (minPriceRange = (minVal / o[0].max) * 100 + "%"),
                            (maxPriceRange = 100 - (maxVal / o[1].max) * 100 + "%"),
                            (rangeselector.style.left = minPriceRange),
                            (rangeselector.style.right = maxPriceRange),
                            (r.querySelector(".filter-option-price-slider").innerHTML = e.querySelector(".filter-option-price-slider").innerHTML);
                    } else if (((r.querySelector(".filter-option-list").innerHTML = e.querySelector(".filter-option-list").innerHTML), r.classList.contains("show-more-filter"))) {
                        let l = r.querySelector(".more-options");
                        if (l) {
                            l.style.display = "block";
                            let i = r.querySelector(".filters-expand");
                            i && (i.classList.add("active"), (i.querySelector("strong").textContent = showLessText));
                        }
                    }
                });
                var i = document.querySelector(".hidden_sort_by"),
                    a = t.querySelector(".sort-by-selected");
                i && a && (i.value = a.value),
                    removeFilter(),
                    applyFilters("updated"),
                    showMoreFilters(),
                    loadMoreCollection(),
                    productCardHoverInit(),
                  productVariantOption(),
                      quantitySelectors(),
                       initaddCartItem(),
                      customDropdownElements();
                                getAddToCartElements(),
                                popupContentElements(),
                                setTimeout(function(){
                                sideDrawerInt();
                                productMedia3dModel();
                                videoPauseOnScroll();
                                },1000)
                        document.dispatchEvent(new CustomEvent("swym:collections-loaded")),
                        animationStatus && AOS && AOS.refreshHard();
                    animationStatus && AOS && AOS.refreshHard(),
                    (triggered = !1),
                    history.pushState({}, null, l);
            });
    }
}

window.addEventListener("load", (e) => {
    loadFiltercontent(),
        filterTriggerOutside(),
        removeFilter(),
        window.addEventListener("scroll", (e) => {
            var t = document.querySelector("[data-scroll]");
            t && infineScroll(t);
        }),
        document.querySelector("[data-dropdown-close]") &&
            document.querySelector("[data-dropdown-close]").addEventListener("click", function (e) {
                e.preventDefault(), document.querySelector("[data-dropdown-body]").classList.remove("is-open");
            });
}),
    window.addEventListener("resize", function () {
        window.innerWidth < 768 && document.querySelector("[data-dropdown-body].is-open") && document.querySelector("[data-dropdown-body].is-open").classList.remove("is-open"),
            document.querySelector(".filter-side-drawer.show") &&
                (document.querySelector(".filter-side-drawer.show").classList.remove("show"), (document.querySelector(".filter-side-drawer").style.display = "none"), document.querySelector("body").classList.remove("no-scroll"));
    });
let triggered = !1;
function infineScroll(e) {
    if (e && e.querySelector("a")) {
        var t = e.querySelector("a").getAttribute("href");
        isOnScreen(e) &&
            !1 == triggered &&
            ((triggered = !0),
            e.querySelector("a").remove(),
            e.querySelector(".load").classList.remove("hidden"),
            fetchFilterData(t).then((t) => {
                e.remove();
                let r = new DOMParser().parseFromString(t, "text/html");
                var o = r.querySelector("[data-products-container]");
                o.querySelector(".applied-filters") && o.removeChild(o.querySelector(".applied-filters"));
                var n = document.querySelector("[data-products-container]");
                if (o) {
                    let l = o.querySelector(".product-count-c");
                    (document.querySelector(".paginate-value>span").textContent = l.textContent), (n.innerHTML += o.innerHTML);
                    Array.from(n.querySelectorAll("[data-quickview-action]")).forEach(function (e) {
                        initQuickView(e);
                    }),
                        colorSwatchesMediaChanged(n),
                        (triggered = !1),
                        loadMoreCollection(),
                        productCardHoverInit(),
                      productVariantOption(),
                      quantitySelectors(),
                       initaddCartItem(),
                      customDropdownElements();
                                getAddToCartElements(),
                                popupContentElements(),
                                setTimeout(function(){
                                sideDrawerInt();
                                productMedia3dModel();
                                videoPauseOnScroll();
                                },1000)
                        document.dispatchEvent(new CustomEvent("swym:collections-loaded")),
                        animationStatus && AOS && AOS.refreshHard();
                }
            }));
    }
}
function loadMoreCollection() {
    var e = document.querySelector(".collection-load-more");
    e &&
        e.addEventListener("click", (e) => {
            e.preventDefault();
            var t = document.querySelector("[data-load-more]");
            t && (infineScroll(t), document.dispatchEvent(new CustomEvent("swym:collections-loaded")));
        });
}
function clearAllFilter() {
    var e = document.getElementById("clearAllFilterData");
    e &&
        e.addEventListener("click", (t) => {
            t.preventDefault();
            var r = document.querySelector("[data-products-container]");
            if (r) {
                var o = r.dataset.id,
                    n = e.getAttribute("href");
                getFilterData(e, o, n);
            }
        });
}
function filterTriggerOutside() {
    let e = !1;
    Array.from(document.querySelectorAll("[data-dropdown-filter],.drawer-main")).forEach(function (t) {
        t.addEventListener("mouseover", () => {
            e = !0;
        }),
            t.addEventListener("mouseout", () => {
                e = !1;
            });
    }),
        document.addEventListener("click", function () {
            !e && document.querySelector(".drawer-main") && document.querySelector(".drawer-main").classList.contains("is-open") && document.querySelector(".drawer-main").classList.remove("is-open");
        }),
        document.addEventListener("keyup", function (e) {
            27 == e.keyCode && document.querySelector(".drawer-main") && document.querySelector(".drawer-main").classList.contains("is-open") && document.querySelector(".drawer-main").classList.remove("is-open");
        });
}
function loadFiltercontent() {
    applyFilters(), sortByOptions(), showMoreFilters(), dropDownBar(), loadMoreCollection(), clearAllFilter(), filterTriggerOutside(), removeFilter();
}
document.addEventListener("shopify:section:load", loadFiltercontent, !1);
